import React from 'react';
import {CoinsStat} from "../PlayerStat/stats/CoinsStat";
import {WinPointsStat} from "../PlayerStat/stats/WinPointsStat";
import DescriptionValueWithIcon from "../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";
import {
  UNIT_SIZE_FOR_SUPPLY_ON_BARRACKS,
  UNIT_SIZE_FOR_SUPPLY_ON_OTHER,
  UNIT_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP
} from "../../constants/units";
import {FARM_SUPPLY_STANDARD_COUNT, FARM_SUPPLY_WITH_WAREHOUSE_COUNT} from "../../constants/supply";
import {FORTRESS_MAX_DAMAGE} from "../../configs/specialBuildings";
import {SPECIAL_BUILDING_TOKENS, TOKENS} from "../../constants/tokens";
import {MINE_EXPLORATION, MINE_EXPLORATION_CONFIG} from "../../configs/factions/dwarves";
import {checkIfCentralQuarter} from "../../utils/buildings/checkIfCentralQuarter";
import {MASKED_ICON_TONES, MaskedIcon} from '../coloredIcons/MaskedIcon/MaskedIcon';
import './BuildingDescription.css';

const BuildingDescription = ({
  buildingId, detailedMode = true, titleDataId, renderPart = 'all', farmSupplyCount, barracksSupplySize,
}) => {
  const cost = (amount) => (
    <CoinsStat
      text={amount}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />
  );

  const renderTitle = (title, price) => {
    if (!detailedMode) {
      return null;
    }

    return (
      <>
        <h3 data-building-title-id={titleDataId}>{title}</h3>
        {detailedMode && (
          <div className={'text-controls policy-description_line'}>
            Стоимость: {cost(price)}
          </div>
        )}
      </>
    )
  };

  const renderCondition = (lines) => {
    return (
      <>
        <div
          key={`title`}
          className={`policy-description_line policy-description_line-margin-top-paragraph-large`}
        >
          <span className={'text-controls policy-description_line policy-description-icon-margin-right'}>
            Условие {hammer}:
          </span>

          {!detailedMode && (
            <span className={'policy-description_line policy-description-icon-margin-right'}>
              {lines[0]}
            </span>
          )}
        </div>

        {lines.map((line, index) => {
          if (!detailedMode && index === 0) {
            return null;
          }

          return (
            <div key={`${index}_line`} className={`policy-description_line policy-description_line-margin-top`}>
              {line}
            </div>
          )
        })}
      </>
    );
  };

  const renderSpecialBuildingCondition = () => (
    <div className={'policy-description_line policy-description_line-margin-top-paragraph-large'}>
        <span className={'text-controls policy-description_line policy-description-icon-margin-right'}>
          Условие {hammer}:
        </span>
      поверх {quarterMarginLeft}.
    </div>
  );

  // Разделение вывода на "мета" (название/цена), "условие" размещения и
  // "описание" — три отдельные колонки таблицы на десктопе. Вне detailedMode
  // разделение не имеет смысла (renderTitle/условие там уже устроены иначе) —
  // renderPart в этом случае игнорируется, части просто конкатенируются
  // (условие — после описания, как было до появления renderPart)
  const combineParts = (meta, condition, description) => {
    if (!detailedMode) {
      return <>{description}{condition}</>;
    }
    if (renderPart === 'meta') {
      return meta;
    }
    if (renderPart === 'condition') {
      return condition;
    }
    if (renderPart === 'description') {
      return description;
    }
    return <>{meta}{condition}{description}</>;
  };

  const coinsOneSize = <img
    className={'construction-phase-info_coins-icon policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/coins.png'}
    alt={'Монеты'}
    title={'Монеты'}
  />;

  const supply = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;
  const supplyMarginLeft = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;

  const hammer = <img
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/hammer brown.png'}
    alt={'Строительство'}
    title={'Строительство'}
  />;

  const speed = <MaskedIcon
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/speed.png'}
    alt="Перемещение"
    title="Перемещение"
    tone={MASKED_ICON_TONES.CONTROLS}
  />;

  const buildingDamage = <img
    className={'policy-description-icon'}
    src={'/img/icons/building_damage.png'}
    alt={'Повреждение'}
    title={'Повреждение'}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;
  const unitMarginLeft = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;
  const unitMarginRight = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right policy-description-icon-unit-margin-no-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  const city = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/city.42008716.png'}
    alt={'Город'}
    title={'Город'}
  />;
  const cityMarginLeft = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/icons/city.42008716.png'}
    alt={'Город'}
    title={'Город'}
  />;

  const guild = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/guild.ee26d2b8.png'}
    alt={'Гильдия'}
  />;

  const temple = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-end'}
    src={'/img/hexes/special buildings/temple.17c08b3d.png'}
    alt={'Храм'}
  />;
  const fortress = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/fortress button.6fed26ae.png'}
    alt={'Крепость'}
  />;

  const quarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/quarter.f69660fa.png'}
    alt={'Базовый квартал'}
    title={'Базовый квартал'}
  />;
  const quarterMarginRight = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/quarter.f69660fa.png'}
    alt={'Базовый квартал'}
    title={'Базовый квартал'}
  />;
  const quarterMarginLeft = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/quarter.f69660fa.png'}
    alt={'Базовый квартал'}
    title={'Базовый квартал'}
  />;

  const centralQuarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/central quarter.7dd51bfd.png'}
    alt={'Центральный квартал'}
    title={'Центральный квартал'}
  />;

  const farm = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/farm.699e6dfc.png'}
    alt={'Ферма'}
    title={'Ферма'}
  />;
  const farmMarginLeftOnly = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left-only'}
    src={'/img/hexes/farm.699e6dfc.png'}
    alt={'Ферма'}
    title={'Ферма'}
  />;
  const farmMarginLeft = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/farm.699e6dfc.png'}
    alt={'Ферма'}
    title={'Ферма'}
  />;


  const barracks = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;
  const barracksMarginLeftOnly = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left-only'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;
  const barracksMarginLeft = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;

  const keyPoint = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/key point.1479d53f.png'}
    alt={'Ключевая точка'}
    title={'Ключевая точка'}
  />;

  const specialBuildings = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/special building.c496c562.png'}
    alt={'Специальное строение'}
    title={'Специальное строение'}
  />;

  const road = <MaskedIcon
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/road.1f281346.png'}
    alt={'Гора'}
    title={'Гора'}
    tone={MASKED_ICON_TONES.CONTROLS}
  />;

  const warehouse = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/special buildings/warehouse.adf397b3.png'}
    alt={'Склад'}
    title={'Склад'}
  />;

  const militaryCamp = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
    alt={'Лагерь'}
    title={'Лагерь'}
  />;

  const arsenal = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/arsenal.7f5423b5.png'}
    alt={'Арсенал'}
    title={'Арсенал'}
  />;

  const size = <MaskedIcon className="faction-description-icon" src="/img/icons/unit size.png" alt="размер"/>;
  const sizeBarracksValueAndIconMarginLeft = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left'}
    value={`+${UNIT_SIZE_FOR_SUPPLY_ON_BARRACKS}`}
    icon={size}
  />;
  // barracksSupplySize — опциональный проп: переопределяет стандартное «+2» для
  // конкретной уже стоящей на поле казармы (см. InspectedCellPanel — там
  // казарма, смежная рабочему военному лагерю, растит отряд на 4). Без него
  // (везде, кроме InspectedCellPanel) поведение не меняется. В описании самого
  // лагеря «а не +2» остается стандартным — там свои значения
  const inspectedBarracksSize = barracksSupplySize ?? UNIT_SIZE_FOR_SUPPLY_ON_BARRACKS;
  const sizeInspectedBarracksValueAndIconMarginLeft = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left'}
    value={`+${inspectedBarracksSize}`}
    icon={size}
  />;
  const sizeInspectedBarracksValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={`+${inspectedBarracksSize}`}
    icon={size}
  />;
  const sizeNotBarracksValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left'}
    value={`+${UNIT_SIZE_FOR_SUPPLY_ON_OTHER}`}
    icon={size}
  />;
  const sizeMilitaryCampValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={`+${UNIT_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP}`}
    icon={size}
  />;
  const sizeOneValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={1}
    icon={size}
  />;
  const sizeOneValueAndIconMarginLeft = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={1}
    icon={size}
  />;
  const sizeTwoValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={2}
    icon={size}
  />;

  const actionNoMargin = <MaskedIcon
    className={'policy-description-icon'}
    src={'/img/icons/action.png'}
    alt={'Действие'}
    title={'Действие в Фазе Строительства'}
  />;
  const palaceActionsValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={`+1`}
    icon={actionNoMargin}
  />;

  const distance = <MaskedIcon
    className={'policy-description-icon'}
    src={'/img/icons/distance.png'}
    alt={'Дальность'}
    title={'Дальность'}
  />;

  const distanceValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={distance}
    icon={5}
  />;

  const supplyNoMargin = <img
    className={'policy-description-icon'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;
  // farmSupplyCount — опциональный проп: переопределяет стандартное «1» для
  // конкретной уже размещенной на поле фермы (см. InspectedCellPanel — там
  // ферма смежная складу производит 2). Без него (везде, кроме
  // InspectedCellPanel, включая оверлей правил фазы строительства через
  // кнопку «Подробнее») поведение не меняется — всегда стандартные 1/3
  const farmSupply1ValueAndIcon = <DescriptionValueWithIcon
    className={'text-supply policy-description-icon-margin-left-end'}
    value={farmSupplyCount ?? FARM_SUPPLY_STANDARD_COUNT}
    icon={supplyNoMargin}
  />;
  const farmSupply2ValueAndIcon = <DescriptionValueWithIcon
    className={'text-supply policy-description-icon-margin-left-end'}
    value={FARM_SUPPLY_WITH_WAREHOUSE_COUNT}
    icon={supplyNoMargin}
  />;

  const cell = <MaskedIcon
    className={'policy-description-icon'}
    src={'/img/icons/cell.png'}
    alt={'Ячейка'}
    title={'Ячейка'}
  />;
  const cellMarginLeft = <MaskedIcon
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/cell.png'}
    alt={'Ячейка'}
    title={'Ячейка'}
  />;
  const quarterZoneValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={2}
    icon={cell}
  />;
  const quarterZoneValueAndIconMarginRightLeft = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={2}
    icon={cell}
  />;

  const guildIncome = <CoinsStat
    text={1}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const templeIncome = <WinPointsStat
    text={1}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const guildBonusIncome = <CoinsStat
    className={'margin-right-important'}
    text={`+1`}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const templeBonusIncome = <WinPointsStat
    className={'margin-right-important'}
    text={`+1`}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const damageNoMargin = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;
  const meleeDamageValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damageNoMargin}
    icon={melee}
  />;
  const damage1ValueAndIcon = <DescriptionValueWithIcon
    className={'text-war policy-description-icon-margin-left-end'}
    value={1}
    icon={damageNoMargin}
  />;
  const buildingDamage1ValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={1}
    icon={buildingDamage}
  />;
  const buildingDamageFortressMaxValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={FORTRESS_MAX_DAMAGE}
    icon={buildingDamage}
  />;

  if (buildingId === MINE_EXPLORATION) {
    const meta = renderTitle(MINE_EXPLORATION_CONFIG.label, MINE_EXPLORATION_CONFIG.priceCoins);
    const mine = <img
      className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
      src={'/img/hexes/mine.ecae90cd.png'}
      alt={'Рудник'}
      title={'Рудник'}
    />;
    const superMine = <img
      className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
      src={'/img/hexes/super_mine.7a4a81f7.png'}
      alt={'Великий рудник'}
      title={'Великий рудник'}
    />;
    const dice = <img
      className={'policy-description-icon policy-description-icon-margin-right-left'}
      src={'/img/icons/dice.png'}
      alt={'Бросок кости'}
      title={'Бросок кости'}
    />;
    const income = (amount) => <span className={'text-coins-dark'}>+{amount}{coinsOneSize}</span>;
    const description = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          Бросок d6{dice}: 1–4 — {mine}{income(1)},
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          5–6 — {superMine}{income(2)}. Бросок не отменить.
        </div>
      </>
    );
    const condition = renderCondition([
      <>смежно {quarter} или {centralQuarter},</>,
      <>на пустой или {road}, не смежно {mine}{superMine}.</>,
    ]);

    return combineParts(meta, condition, description);
  }

  if (buildingId === TOKENS.ROAD) {
    const meta = renderTitle('Дорога', 1);
    const description = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          Развивает пути строительства {hammer},
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          снабжения {supplyMarginLeft}, перемещения {speed}
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          и влияния {guild}{temple}.
        </div>
      </>
    );

    return combineParts(meta, null, description);
  }

  if (buildingId === TOKENS.BARRACKS) {
    const condition = renderCondition([
      <>смежно {quarter} или {centralQuarter}.</>
    ]);

    const main = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          В <span className={'text-war policy-description-icon-margin-right-left'}>фазе Войны</span> позволяет
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          нанимать и улучшать {unit}.
        </div>
        {detailedMode && (
          <>
            <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
              И нанимать для {unit} по {sizeOneValueAndIcon} за {coinsOneSize}
            </div>
            <div className={'policy-description_line policy-description_line-margin-top'}>
              с каждого {centralQuarter}{quarterMarginRight} в городе {city}.
            </div>
          </>
        )}
        <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
          В <span
          className={'text-supply policy-description-icon-margin-left'}
        >фазе Снабжения</span> {unit} со {supply}
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          на {barracks} получает {detailedMode
            ? sizeInspectedBarracksValueAndIconMarginLeft
            : sizeInspectedBarracksValueAndIcon}
          {!detailedMode && (
            <>(а не {sizeNotBarracksValueAndIcon}).</>
          )}
        </div>
        {detailedMode && (
          <div className={'policy-description_line policy-description_line-margin-top'}>
            (на любой другой ячейке {sizeNotBarracksValueAndIcon}).
          </div>
        )}
      </>
    );

    const meta = renderTitle('Казарма', 2);

    return combineParts(meta, condition, main);
  }

  if (buildingId === TOKENS.FARM) {
    const condition = renderCondition([
      <>смежно {quarter} или {centralQuarter}.</>
    ]);

    const main = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          В <span
          className={'text-supply policy-description-icon-margin-right-left'}
        >фазе Снабжения</span> производит {farmSupply1ValueAndIcon}.
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
          Путь снабжения от {farm} до {unitMarginLeft}
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          не более {distanceValueAndIcon}.
        </div>
        {detailedMode && (
          <>
            <div className={'policy-description_line policy-description_line-margin-top policy-description_line-column-start'}>
              Путь снабжения продлевается при
            </div>
            <div className={'policy-description_line policy-description_line-margin-top'}>
              передаче {supply} от {farm} к {farm} по цепочке.
            </div>
          </>
        )}
      </>
    );

    const meta = renderTitle('Ферма', 3);

    return combineParts(meta, condition, main);
  }

  if (checkIfCentralQuarter(buildingId)) {
    const condition = renderCondition([
      <>не ближе {quarterZoneValueAndIcon}</>,
      <>от {centralQuarter} {quarterMarginRight} других {cityMarginLeft}.</>
    ]);

    const main = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-large'}>
          Основание города {cityMarginLeft}.
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
          Контроль смежных {farmMarginLeftOnly}{barracksMarginLeftOnly}{keyPoint}.
        </div>
      </>
    );

    const meta = renderTitle('Центральный квартал', 4);

    return combineParts(meta, condition, main);
  }

  if (buildingId === TOKENS.QUARTER) {
    const conditionItems = [
      <>смежно {centralQuarter}.</>,
    ]

    if (detailedMode) {
      conditionItems.push(
        <>И не ближе {quarterZoneValueAndIconMarginRightLeft}</>,
        <>от {centralQuarter} {quarterMarginRight} других {cityMarginLeft}.</>
      )
    } else {
      conditionItems.push(
        <>И не
          ближе {quarterZoneValueAndIconMarginRightLeft} от {centralQuarter} {quarterMarginRight} других {cityMarginLeft}.</>
      )
    }

    const condition = renderCondition(conditionItems);

    const main = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-large'}>
          Расширение города {city} для
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          строительства {specialBuildings} поверх {quarterMarginLeft}.
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
          Контроль смежных {farmMarginLeftOnly}{barracksMarginLeftOnly}{keyPoint}.
        </div>
      </>
    );

    const meta = renderTitle('Базовый квартал', 2);

    return combineParts(meta, condition, main);
  }

  if (buildingId === SPECIAL_BUILDING_TOKENS.PALACE) {
    const meta = renderTitle('Дворец', 10);
    const description = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          В <span
          className={'text-construction'}
        >фазе Строительства</span> {palaceActionsValueAndIcon}.
        </div>
        {!detailedMode && renderSpecialBuildingCondition()}
      </>
    );

    return combineParts(meta, null, description);
  }

  if (buildingId === SPECIAL_BUILDING_TOKENS.WAREHOUSE) {
    const meta = renderTitle('Склад', 10);
    const description = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          В <span
          className={'text-supply policy-description-icon-margin-left'}
        >фазе Снабжения</span> {farmMarginLeft},
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          смежные {warehouse}, производят по {farmSupply2ValueAndIcon}.
        </div>
        {!detailedMode && renderSpecialBuildingCondition()}
      </>
    );

    return combineParts(meta, null, description);
  }

  if (buildingId === SPECIAL_BUILDING_TOKENS.MILITARY_CAMP) {
    const meta = renderTitle('Лагерь', 8);
    const description = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          В
          <span
            className={'text-supply policy-description-icon-margin-right-left'}
          >
            фазе Снабжения
          </span>
          все {unit} со {supply}
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          на {barracksMarginLeft}, смежных {militaryCamp},
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          получают {sizeMilitaryCampValueAndIcon} (а не {sizeBarracksValueAndIconMarginLeft}).
        </div>
        {!detailedMode && renderSpecialBuildingCondition()}
      </>
    );

    return combineParts(meta, null, description);
  }

  if (buildingId === SPECIAL_BUILDING_TOKENS.ARSENAL) {
    const meta = renderTitle('Арсенал', 8);
    const description = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          В <span className={'text-war policy-description-icon-margin-right-left'}>фазе Войны</span> в
          городе {city} с {arsenal}
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          с каждого {centralQuarter}{quarterMarginRight} за {coinsOneSize}
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          для {unit} нанимается сразу по {sizeTwoValueAndIcon}
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          (а не по {sizeOneValueAndIconMarginLeft}).
        </div>
        {!detailedMode && renderSpecialBuildingCondition()}
      </>
    );

    return combineParts(meta, null, description);
  }

  if (buildingId === SPECIAL_BUILDING_TOKENS.TEMPLE) {
    const meta = renderTitle('Храм', 6);
    const description = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          <span
            className={'text-win-points-dark policy-description-icon-margin-right'}
          >Доход</span> {templeIncome}.
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
          <span className={'text-win-points-dark policy-description-icon-margin-right'}>Доход</span>
          {templeBonusIncome} за каждый вражеский {cityMarginLeft},
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          до которого можно провести
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          <span className={'text-win-points-dark'}>путь влияния</span> {distanceValueAndIcon}.
        </div>
        {!detailedMode && renderSpecialBuildingCondition()}
      </>
    );

    return combineParts(meta, null, description);
  }

  if (buildingId === SPECIAL_BUILDING_TOKENS.GUILD) {
    const meta = renderTitle('Гильдия', 4);
    const description = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          <span className={'text-coins-dark policy-description-icon-margin-right'}>Доход</span> {guildIncome}.
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
          <span className={'text-coins-dark policy-description-icon-margin-right'}>Доход</span>
          {guildBonusIncome} за каждый вражеский {cityMarginLeft},
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          до которого можно провести
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          <span className={'text-coins-dark'}>путь влияния</span> {distanceValueAndIcon}.
        </div>
        {!detailedMode && renderSpecialBuildingCondition()}
      </>
    );

    return combineParts(meta, null, description);
  }

  if (buildingId === SPECIAL_BUILDING_TOKENS.FORTRESS) {
    const condition = renderCondition([
      <>на любой непустой {cellMarginLeft},</>,
      <>кроме {road} и {specialBuildings}.</>
    ]);

    const main = (
      <>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-large'}>
          За {buildingDamage1ValueAndIcon} поглощает
          <span className={'text-war policy-description-icon-margin-right-left'}>2</span>
          из
          <span className={'text-war policy-description-icon-margin-left'}>3</span>
          {meleeDamageValueAndIcon}.
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          {unitMarginRight} в {fortress} получает только {damage1ValueAndIcon}.
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
          Разрушается, когда получает {buildingDamageFortressMaxValueAndIcon}.
        </div>
      </>
    );

    const meta = renderTitle('Крепость', 8);

    return combineParts(meta, condition, main);
  }

  return null;
};

export default BuildingDescription;
